import { Link } from "react-router-dom";

type EventEntryErrorScreenProps = {
  applyError: string;
  userErrorMessage: string | null;
  showRetry: boolean;
  onRetry: () => void;
};

export function EventEntryErrorScreen({
  applyError,
  userErrorMessage,
  showRetry,
  onRetry,
}: EventEntryErrorScreenProps) {
  return (
    <div
      className="flex min-h-screen flex-col items-center justify-center bg-gray-50 p-8"
      data-testid="event-entry-error"
    >
      <div className="max-w-md text-center">
        <h2 className="text-xl font-semibold text-gray-900">Could not join event</h2>
        <p className="mt-2 text-gray-600">{applyError}</p>
        {userErrorMessage ? <p className="mt-2 text-sm text-red-600">{userErrorMessage}</p> : null}
        <div className="mt-6 flex flex-col gap-3 sm:flex-row sm:justify-center">
          {showRetry ? (
            <button
              type="button"
              className="rounded-lg bg-pink-600 px-4 py-2 text-sm font-semibold text-white hover:bg-pink-500"
              data-testid="event-entry-retry"
              onClick={onRetry}
            >
              Try again
            </button>
          ) : null}
          <Link
            to="/discover"
            className="rounded-lg border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-100"
            data-testid="event-entry-continue-discover"
          >
            Continue to app
          </Link>
        </div>
      </div>
    </div>
  );
}
